import { render, staticRenderFns } from "./SocialModal.vue?vue&type=template&id=5e2fa037&"
import script from "./SocialModal.vue?vue&type=script&lang=js&"
export * from "./SocialModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports